import type { OnboardingOfferKey } from "@/services/api-hooks/offers";

const OFFER_TYPE = "post_sub_upsell";
const OFFER_TRANSACTION_TYPE = "one-time";
const OFFER_SOURCE = "onboarding";

export const OFFER_PAY_PROVIDER = "card";

interface OfferAnalyticsBaseParams {
  offer_type: string;
  upsale_type: string;
  type: string;
  source: string;
}

export const buildOfferAnalyticsBaseParams = (
  offerKey: OnboardingOfferKey,
): OfferAnalyticsBaseParams => ({
  offer_type: OFFER_TYPE,
  upsale_type: offerKey,
  type: OFFER_TRANSACTION_TYPE,
  source: OFFER_SOURCE,
});
